var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58.11px",
    height: "70.99px",
    viewBox: "0 0 58.11 70.99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-270.290000, -2419.650000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "translate(-0.060000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.46,2432.08 L328.46,2476.56 L299.4,2490.64 L270.35,2476.56 L270.35,2419.65 L299.4,2419.65 L299.4,2428.06 L278.75,2428.06 L278.75,2471.31 L299.4,2481.33 L320.05,2471.31 L320.05,2432.08 L328.46,2432.08 Z M307.65,2465.58 L299.4,2457.33 L291.15,2465.58 L285.21,2459.64 L293.46,2451.39 L285.21,2443.13 L291.15,2437.19 L299.4,2445.44 L307.65,2437.19 L313.6,2443.13 L305.35,2451.39 L313.6,2459.64 L307.65,2465.58 Z",
    id: "Path_123",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_124",
    fill: "#BEB0FF",
    points: "303.61 2419.66 328.46 2419.66 328.46 2428.06 303.61 2428.06"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/Icon10.17181554bc1a86025065740be86c5bbc.svg";
export { ForwardRef as ReactComponent };